import React, { Component } from 'react'
import { Link } from "react-router-dom";
import ContactUs from '../components/ContactUs';
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";


export class Contact extends Component {
    constructor(props) {
                    super(props);
                
                    this.state = {
                      seo: null,
                    };
                  }
                
                async componentDidMount() {
                    const seoData = await getSEO("contact");
                
                    this.setState({
                      seo: seoData,
                    });
        }
  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />

          {/* Hero Start */}
        <div class="container-fluid pb-5 hero-header mb-5">
            <div class="container py-5">
                <div class="row g-3 align-items-center">
                    <div class="col-lg-6 text-center text-lg-start">
                        <h1 class="display-3 mb-0 animated slideInLeft">Contact</h1>
                    </div>
                    <div class="col-lg-6 animated slideInRight">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb justify-content-center justify-content-lg-end mb-0">
                                <li class="breadcrumb-item"><Link class="text-secondary" to="/">Home</Link></li>
                                <li class="breadcrumb-item active" aria-current="page">Contact</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        {/* Hero End */}

        <ContactUs/>
      </div>
    )
  }
}

export default Contact

